import { inject, Injectable } from '@angular/core';
import { DefaultService } from '@common/references/default.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import {
  BookingAssignComponent
} from '@modules/universal-billing/accounting/bookings/booking-assign/booking-assign.component';


@Injectable({providedIn: "root"})
export class BookingAssignService extends DefaultService<any> {
  backendName = 'datev-booking-documents';
  title = 'Booking Assign';
  formComponent = BookingAssignComponent;


  translate = inject(TranslateService);

  getUrl(): string {
    return environment.apiUrl + '/datev-booking-documents';
  }



}
